import { Box, Modal } from "@mui/material";
import { AlertType, Holiday } from "../../models";
import { useCallback } from "react";
import { BuildUrl } from "../../helpers";
import { useAlertContext, useUserContext } from "../../contexts";
import { useMsal } from "@azure/msal-react";
import { apiAccessRequest } from "../../constants";

interface DeleteHolidayModalProps {
	open: boolean;
	holiday: Holiday | undefined;
	onClose: (isUpdated: boolean) => void;
}

export const DeleteHolidayModal = ({
	open,
	holiday,
	onClose
}: DeleteHolidayModalProps) => {
	const { showAlert } = useAlertContext();
	const { account } = useUserContext();
	const { instance } = useMsal();

	const handleConfirm = useCallback(async () => {
		try {
			const requestUrl = BuildUrl(`Holiday/${holiday?.id}`);
			const tokenResponse = await instance.acquireTokenSilent({
				account,
				scopes: apiAccessRequest.scopes
			});
			const headers = {
				Authorization: `Bearer ${tokenResponse.accessToken}`
			};
			const response = await fetch(requestUrl, {
				method: "DELETE",
				headers
			});

			if (!response.ok) {
				throw new Error("Network response was not ok");
			}
			showAlert({
				message: "Holiday was deleted",
				alertType: AlertType.success,
				timeout: true
			});
			onClose(true);
		} catch (error) {
			console.info(error);
			showAlert({
				message: "Holiday was not deleted",
				alertType: AlertType.error
			});
			return;
		}
	}, [account, holiday?.id, instance, onClose, showAlert]);

	return (
		<Modal
			open={open}
			onClose={() => onClose(false)}
			aria-labelledby="delete-modal-title"
			aria-describedby="delete-modal-description"
		>
			<Box className="modal" sx={{ width: 400 }}>
				<div id="delete-modal-title" className="ch-l-text flex justify-center">
					Delete {holiday?.description}
				</div>
				<p id="delete-modal-description" className="py-4">
					Are you sure you want to delete {holiday?.description}?
				</p>
				<div style={{ display: "flex", justifyContent: "center", gap: 20 }}>
					<button
						className="ch-button ch-button-primary"
						onClick={() => onClose(false)}
					>
						No
					</button>
					<button
						className="ch-button ch-button-secondary"
						onClick={() => handleConfirm()}
					>
						Yes
					</button>
				</div>
			</Box>
		</Modal>
	);
};
